import { Redirect } from 'expo-router'

/** Root entry → the portal home (which carries the sidebar/topbar chrome). */
export default function Index() {
  return <Redirect href="/home" />
}
